// extracted by mini-css-extract-plugin
export default {"logoDiv":"Logo_logoDiv__EJdw8"};